export enum CarPart {
  Front = 'front',
  Left = 'left',
  Back = 'back',
  Right = 'right',
  Top = 'top'
}
